import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import { createAPI, updateAPI, getListAllAPI } from '../../../services';
import { TextInput, ColorInput, IconInput, SwitchInput } from '../../Inputs';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    // backgroundColor: (props) => props.cor,
    // color: 'white',
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    // backgroundColor: 'rgba(0, 0, 0, 0.12)',
    // color: 'red',
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DEFAULT_NOME = '';
const DEFAULT_COLOR = '#f44336';
const DEFAULT_ICON = 'search';
const DEFAULT_CONTAILIZA_LUCRO = false;
const DEFAULT_ID = -1;
const DEFAULT_TIPO_CATEGORIA = 'Receita';
const DEFAULT_COR_TIPO_CATEGORIA = 'green';

const RECEITA = 'Receita';
const DESPESA = 'Despesa';

const DialogoCategoriaTransacao = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [nome, setNome] = useState(DEFAULT_NOME);
  const [color, setColor] = useState(DEFAULT_COLOR);
  const [icon, setIcon] = useState(DEFAULT_ICON);
  const [contabilizaLucro, setContabilizaLucro] = useState(
    DEFAULT_CONTAILIZA_LUCRO,
  );
  const [id, setId] = useState(DEFAULT_ID);
  const [tipoCategoria, setTipoCategoria] = useState(DEFAULT_TIPO_CATEGORIA);
  const [corTipoTransacao, setCorTipoTransacao] = useState(
    DEFAULT_COR_TIPO_CATEGORIA,
  );
  const [carregando, setCarregando] = useState(false);

  const classes = useStyles({ cor: corTipoTransacao });

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  async function reiniciar(tipoCategoria) {
    setNome(DEFAULT_NOME);
    setId(DEFAULT_ID);
    setColor(DEFAULT_COLOR);
    setIcon(DEFAULT_ICON);
    setContabilizaLucro(DEFAULT_CONTAILIZA_LUCRO);
    setTipoCategoria(tipoCategoria);
    setCorTipoTransacao(tipoCategoria === RECEITA ? 'green' : 'red');
    setCarregando(false);
  }

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'categorias_transacao',
        ['id', 'asc'],
        { id: [id] },
        [],
      );
      if (data.data.length > 0) {
        setNome(data.data[0].nome);
        setId(data.data[0].id);
        setColor(data.data[0].color);
        setIcon(data.data[0].icon);
        setContabilizaLucro(data.data[0].contabiliza_no_lucro);
        setTipoCategoria(data.data[0].tipo);
        setCorTipoTransacao(data.data[0].tipo === RECEITA ? 'green' : 'red');
        setCarregando(false);
      } else {
        throw 'Esta categoria não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  async function handleSalvar() {
    setCarregando(true);
    try {
      if (id <= 0) {
        await createAPI('categorias_transacao', {
          nome,
          color,
          icon,
          tipo: tipoCategoria,
          contabiliza_no_lucro: contabilizaLucro,
        });
        setCarregando(false);
        enqueueSnackbar('Categoria de transação criada com sucesso!', {
          variant: 'success',
        });
      } else {
        await updateAPI('categorias_transacao', id, {
          nome,
          color,
          icon,
          contabiliza_no_lucro: contabilizaLucro,
        });
        setCarregando(false);
        enqueueSnackbar('Categoria de transação atualizada com sucesso!', {
          variant: 'success',
        });
      }

      handleCloseDialog();
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleCreate(tipoCategoria) {
      reiniciar(tipoCategoria);
      setOpen(true);
    },
    handleEdit(id) {
      setCarregando(true);
      getDataResource(id);
      setId(id);
      setOpen(true);
    },
  }));

  function getColor() {
    switch (tipoCategoria) {
      case RECEITA:
        return '#4caf50';
      case DESPESA:
        return '#f44336';
      default:
        return '#009FD4';
    }
  }

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{ backgroundColor: getColor(), color: 'white' }}
        >
          {id < 0
            ? `Nova Categoria de ${tipoCategoria}`
            : `Editar Categoria de ${tipoCategoria}`}
        </DialogTitle>
        <DialogContent
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          {carregando ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div>
              <TextInput
                name="nome"
                handleEnter={() => {}}
                label="Nome"
                handleKey={() => {}}
                value={nome}
                onChange={(value) => setNome(value.target.value)}
                error={nome === '' || nome.length > 80}
                helperText={
                  nome === ''
                    ? 'Este campo é obrigatório'
                    : nome.length > 80
                    ? 'nÚMERO DE CARACTERES TEM QUE SER MENOS QUE 80!'
                    : ''
                }
                fullWidth
                autoFocus
                variant="standard"
              />
              <div style={{ marginTop: '24px' }}>
                <div>
                  <div>Cor da categoria</div>
                </div>
                <div style={{ margin: '16px 6.4px' }}>
                  <ColorInput
                    value={color}
                    onChange={(newColor) => setColor(newColor)}
                  />
                </div>
              </div>
              <div style={{ marginTop: '30px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div>Ícone</div>
                </div>
                <div style={{ margin: '16px 6.4px' }}>
                  <IconInput
                    value={icon}
                    onChange={(newIcon) => setIcon(newIcon)}
                  />
                </div>
              </div>
              <div
                style={{
                  marginTop: '30px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <AttachMoneyIcon style={{ marginRight: '24px' }} />
                  <div style={{ fontWeight: 'bold' }}>Incluir no lucro</div>
                </div>
                <SwitchInput
                  name="lucro"
                  handleEnter={() => {}}
                  label=""
                  handleKey={() => {}}
                  checked={contabilizaLucro}
                  onChange={(value) =>
                    setContabilizaLucro(value.target.checked)
                  }
                />
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          <div className={classes.wrapper}>
            <Button
              onClick={handleSalvar}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              disabled={nome === '' || nome.length > 80 || carregando}
              variant="contained"
              color="primary"
            >
              Salvar
            </Button>
            {carregando && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
